export default {
  'en-US': {
    workOrderControlSelection: {
      placeholder: 'Please select an action...',
      ConstructBox: 'Construct my box/packaging',
      ClosePackage: 'Close my box/packaging',
      PlaceItem: 'Place an item inside my kit',
      AffixLabel: 'Affix my sticker/label/barcode to an item',
      AffixShipBobLabel: 'Affix a ShipBob-printed sticker',
      RemovePackaging: 'Remove packaging or an insert',
      AddDunnage: 'Add my dunnage to the kit',
      AddShipBobDunnage: 'Add ShipBob paper dunnage to the kit',
      ConstructBoxDivider: 'Construct my box divider/insert',
      WrapItem: 'Wrap my item',
      AffixCustomSticker: 'Seal an item shut with tape/sticker',
      InspectItem: 'Perform inspection of an item',
      RemoveItemFromPackage: 'Remove item from package',
      ChangeSku: 'Change item SKU to kit SKU',
      PackInShipbobPackage: 'Pack item in ShipBob packaging'
    },
    workOrderPrimarySubAction: {
      default: 'Select',
      ItemPlacedIn: 'Select item',
      LabelToAffix: 'Item will be affixed to',
      DunnageToAdd: 'Select dunnage',
      ItemToWrap: 'Select wrapping',
      CustomStickerAffixedTo: 'Select tape/sticker',
      ShipBobPackageSelected: 'Select packaging to use'
    },
    workOrderSubAction: {
      default: 'Select',
      LabelSpecialPositioning: 'Check this box if you need the label to be affixed to the same location every time. Describe the exact location below.'
    },
    workOrderProduct: {
      default: 'Select Item',
      ConstructBox: 'Select item',
      ClosePackage: 'Select item',
      PlaceItem: 'Item will be placed into',
      AffixLabel: 'Select sticker/label/barcode',
      AffixShipBobLabel: 'Item will be affixed to',
      RemovePackaging: 'Select item',
      AddDunnage: 'Dunnage will be placed inside',
      AddShipBobDunnage: 'Dunnage will be placed inside',
      ConstructBoxDivider: 'Select Item',
      WrapItem: 'Item that will be wrapped',
      AffixCustomSticker: 'Item that will be sealed',
      InspectItem: 'Select item to inspect',
      RemoveItemFromPackage: 'Select Item',
      ChangeSku: 'Select Item',
      PackInShipbobPackage: 'Select Item'
    },
    workOrderHeadsUp: {
      default: 'Please select an action.',
      ConstructBox: 'Please describe and add photos for how your package needs to be constructed. Remember to include an action for closing the box as the last step of your kit.',
      ClosePackage: 'Always include this action to ensure our packers know how to close out the package.',
      PlaceItem: 'Use this action for any product you need to add into your kit.',
      AffixLabel: 'Make sure to specify both the sticker being used and the product receiving the label. Both must be included in this order.',
      AffixShipBobLabel: 'Make sure you include the barcodes we need to print as an attachment on the order!',
      RemovePackaging: 'Please specify the material being removed in the description.',
      AddDunnage: 'Please indicate the product you are placing dunnage into in addition to the dunnage being used. Both must be included in this order.',
      AddShipBobDunnage: 'The Product here should be the item we are adding paper dunnage into.',
      ConstructBoxDivider: 'Please include a photo of how your insert should be constructed.',
      WrapItem: 'If you would like to seal the wrapping shut, please include an additional action to Seal Package.',
      AffixCustomSticker: 'The Product here should be the sticker/tape you are using to seal the package.',
      InspectItem: 'Use this action for a step where you would like us to inspect an item.',
      RemoveItemFromPackage: 'Select this option if the item being removed will be reused in the final kit.',
      ChangeSku: 'Use this action if you simply want to store the selected item as the end-kitted SKU without modification.',
      PackInShipbobPackage: 'Please specify the item that will be packed, and the standard packaging to use.'
    },
    kittingRequestError: {
      endKittedProduct: 'End-kitted item not valid.',
      selectedProductsToKit: 'Selected item(s) in kit not valid.',
      instructionsContainsProducts: 'Instructions invalid. You must assign an action to perform for each item in the kit.',
      wrongUser: 'User info has changed. Please cancel and start over.',
      failedToRetrieveEstimateError: 'No Price estimates available for the specified fulfillment center. Please reach out to merchant care team.',
      default: 'Error occurred, please try again.'
    }
  }
}
